import React, {lazy} from 'react';
import {Route} from 'react-router-dom';


import RootRoutes from '../../../roots/RootRoutes';
import {authConstants} from '../../../contexts/Auth';

const LoginPage = lazy(() => import('./LoginPage'));
const LogoutPage = lazy(() => import('./LogoutPage'));


function Index() {


    return (
        <RootRoutes>

            <Route
                element={<LoginPage/>}
                exact={true}
                path={authConstants.NAV_LOGIN}
            />

            <Route
                element={<LogoutPage/>}
                exact={true}
                path={authConstants.NAV_LOGOUT}
            />

        </RootRoutes>
    );
}


export default Index;
